import { gql } from '@apollo/client';
import { NoteFragments } from '../../fragments/note/note.fragments';

export const UPDATE_USERS_NOTE = gql`
  mutation UpdateAllNote {
    updateAllNote {
      ...Quantite
      ...Moyenne
      user {
        data {
          id
          attributes {
            firstname
            lastname
          }
        }
      }
    }
  }
  ${NoteFragments.fragments.Quantite}
  ${NoteFragments.fragments.Moyenne}
`;
